import type {
  AddressFormField,
  AddressFormInitialValues,
  AddressFormProps,
  StepValidationFields,
} from '@gasbi/shared/web/forms/AddressForm';
import {
  AddressFormContextProvider,
  AddressForm as SharedAddressForm,
  addressFormInitialValues,
  addressFormValidationFields,
  addressFormValidationSchema,
  conditionalRequired,
  useAddressFormContext,
} from '@gasbi/shared/web/forms/AddressForm';

import {
  addressesApi,
  useGetBuildingNumbersQuery,
  useGetSettlementsIInfiniteQuery,
  useGetStreetIInfiniteQuery,
} from '@/features/addresses/addressesApi';

export type {
  AddressFormProps,
  AddressFormField,
  AddressFormInitialValues,
  StepValidationFields,
};

export {
  useAddressFormContext,
  AddressFormContextProvider,
  addressFormInitialValues,
  conditionalRequired,
  addressFormValidationFields,
  addressFormValidationSchema,
};

export const AddressForm = (props: AddressFormProps) => (
  <AddressFormContextProvider
    value={{
      addressesApi: {
        ...addressesApi,
        useGetBuildingNumbersQuery,
        useGetSettlementsIInfiniteQuery,
        useGetStreetIInfiniteQuery,
      },
    }}
  >
    <SharedAddressForm {...props} />
  </AddressFormContextProvider>
);
